var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHidePasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_16",
    "data-name": "Layer 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.545,
    height: 27.518,
    viewBox: "0 0 38.545 27.518",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M31.6,111.749,6.948,87.1l-.005-.006a1.431,1.431,0,1,0-2.016,2.033l2.158,2.158a25.043,25.043,0,0,0-6.639,6.7,2.576,2.576,0,0,0,0,2.889c4.515,6.682,11.672,10.6,18.829,10.548a20.447,20.447,0,0,0,6.81-1.141l3.494,3.494a1.43,1.43,0,1,0,2.028-2.017Zm-12.325-4.214a8.114,8.114,0,0,1-7.391-11.457l2.255,2.255a5.251,5.251,0,0,0,6.227,6.227l2.255,2.255a8.073,8.073,0,0,1-3.346.72Z",
    transform: "translate(-0.003 -86.676)",
    fill: "#b4b0b0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M191.179,107.2c-4.515-6.686-11.672-10.6-18.829-10.552a20.447,20.447,0,0,0-6.81,1.141L169,101.249a8.114,8.114,0,0,1,10.738,10.738l4.8,4.8a25.031,25.031,0,0,0,6.64-6.7A2.576,2.576,0,0,0,191.179,107.2Z",
    transform: "translate(-153.078 -95.894)",
    fill: "#b4b0b0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M242.609,186.26a5.261,5.261,0,0,0-1.09.114l6.226,6.226a5.25,5.25,0,0,0-5.136-6.34Z",
    transform: "translate(-223.336 -178.763)",
    fill: "#b4b0b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/hide_password_icon.7af98a1010e42f1c5659d5be2f2c538b.svg";
export { ForwardRef as ReactComponent };